import { io, Socket } from "socket.io-client";

class SocketService {
  private sockets: Map<string, Socket> = new Map();

  public connect(actorId: string, dispatch: any): Socket {
    if (this.sockets.has(actorId)) {
      const existing = this.sockets.get(actorId)!;
      if (!existing.connected) {
        existing.connect();
      }
      return existing;
    }

    const socket = io(process.env.REACT_APP_URL || "", {
      withCredentials: true,
      autoConnect: true,
      transports: ["websocket"],
    });

    socket.on("connect_error", () => {});
    socket.on("disconnect", () => {});

    this.sockets.set(actorId, socket);
    return socket;
  }

  public disconnect(actorId: string): void {
    const socket = this.sockets.get(actorId);
    if (socket) {
      socket.disconnect();
      this.sockets.delete(actorId);
    }
  }

  public getSocket(actorId: string): Socket | undefined {
    return this.sockets.get(actorId);
  }

  public isConnected(actorId: string): boolean {
    const socket = this.sockets.get(actorId);
    return socket ? socket.connected : false;
  }
}

const socketService = new SocketService();
export default socketService;
